import baseRequest from '../_core';

const otpService = {
  // Send OTP to user's email after registration
  sendOTP: (params) =>
    baseRequest.post('/sendOTP', {
      email: params.email,
    }),

  // Verify the OTP entered by user
  verifyOTP: (params) =>
    baseRequest.post('/verifyOTP', {
      email: params.email,
      otp: params.otp,
    }),

  // Verify the OTP for company registration
  verifyCompanyOTP: (params) =>
    baseRequest.post('/com_verifyOTP', {
      email: params.email,
      otp: params.otp,
      isCompany: true
    }),

  // Resend OTP if user didn't receive it
  resendOTP: (params) =>
    baseRequest.post('/resendOTP', {
      email: params.email,
    }),

  // Resend OTP for company registration
  resendCompanyOTP: (params) =>
    baseRequest.post('/com_resendOTP', {
      email: params.email,
      isCompany: true

    }),
};

export default otpService; 